export const queryKeys = {
  base: () => ['recommendations'],
  summary: () => [...queryKeys.base(), 'summary'],
};
